<template>
  <header
    :class="[
      'public-header',
      className,
      hasBottomBorder ? 'bottom-border' : '',
      page,
      isNew ? 'is-new' : '',
      layoutVersion,
      isNewLayout ? 'new-version' : '',
      displayLayout,
      displayHorizontal ? 'horizontal' : '',
    ]"
    :style="{
      backgroundImage: `url(${headerImage})`,
      backgroundSize: '100% 100%',
      backgroundColor: backColor,
      border: '0px solid',
    }"
    v-show="!isApp"
  >
    <!-- CMS 配置头图 -->
    <img class="icon-pic" :src="iconPic" v-if="iconPic" />
    <span v-if="showBack" class="back-icon" @click="back">
      <MBIcon :name="iconName" :size="iconSize" :color="iconColor" />
    </span>
    <p
      :class="headerTitleCls"
      :style="{
        color: titleFontColor,
      }"
    >
      {{ title }}
    </p>
    <span class="right-icon">
      <slot></slot>
    </span>
  </header>
</template>

<script>
  import MBIcon from '@/components/MBIcon'
  import { mapState, mapGetters } from 'vuex'
  import { darkBgPages } from '@/consts/index.js'
  import { getCurrentPage } from '@/utils/utils.js'

  export default {
    name: 'public-header',
    components: {
      MBIcon,
    },
    props: {
      title: {
        default: 'TopLupe',
        type: String,
      },
      directBack: {
        default: true,
        type: Boolean,
      },
      hasBottomBorder: {
        default: true,
        type: Boolean,
      },
      showBack: {
        default: true,
        type: Boolean,
      },
      headerImage: {
        default: '',
        type: String,
      },
      iconPic: {
        default: '',
        type: String,
      },
      page: {
        require: true,
        type: String,
      },
      isNew: {
        // 是否是新模式
        default: false,
        type: Boolean,
      },
      iconName: {
        default: 'icon-arrow',
        type: String,
      },
      iconColor: {
        default: '#000',
        type: String,
      },
      titleColor: {
        type: String,
      },
      borderBottom: {
        default: false,
        type: Boolean,
      },
      backColor: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapState(['isMobile', 'isApp', 'layoutVersion']),
      ...mapGetters(['isNewLayout', 'displayHorizontal', 'displayLayout']),
      className() {
        return this.isMobile ? 'displayMobile' : 'displayDesktop'
      },
      iconSize() {
        if (this.displayHorizontal) return 30
        return this.isMobile ? 50 : 20
      },
      titleFontColor() {
        const currentPage = getCurrentPage(this.$route.path)
        return (
          this.titleColor ||
          (darkBgPages.includes(currentPage) &&
          this.layoutVersion === 'version-2'
            ? '#fff'
            : '#000000e6')
        )
      },
      headerTitleCls() {
        const des = ['header-title']
        if (this.page === 'pay-result') {
          des.push('custom-header-title')
        }
        if (this.borderBottom) {
          des.push('borderBottom-title')
        }
        return des
      },
    },
    methods: {
      back() {
        if (this.directBack) {
          this.$router.go(-1)
        }
        this.$emit('click')
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index.scss';
  }
</style>
